<a href="#" [title]="openText" class="btn btn--more"
    (click)="target.toggle()">
    <span *ngIf="!target.visible">{{ openText }}</span>
    <span *ngIf="target.visible">{{ closeText }}</span>
    
    <svg *ngIf="target.visible" class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#pijl-up-bold"></use></svg>
    <svg *ngIf="!target.visible" class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#pijl-down-bold"></use></svg>
</a>